import { EventBus } from '@/utils/eventBus';
export default {
  components: {
  },
  props: {},
  data() {
    return {
      url: {
        save: SZH.assets.api + '/Login/Login',
        LoginForPhone: SZH.assets.api + '/Login/LoginForPhone',
        GetClientsUserJson: SZH.assets.api + '/ClientsData/GetClientsUserJson',
        Join: SZH.assets.api + '/Notice/Join',
        RefrenshScanCode: SZH.assets.api + '/Notice/RefrenshScanCode',
        ScanLogin: SZH.assets.api + '/Login/ScanLogin',
      },
      captchaUrl: SZH.assets.api + '/Login/GetAuthCode',
      SendVerifyCodeForLogin: SZH.assets.api + '/Login/SendCode',

      captchaUrlTails: 'feelingscoder',
      checked: true,
      form: {
        Username: '', // 登录账号
        Password: '', // 登录密码
        Captcha: '', // 验证码 2021/11/8
      },
      rules: {},
      checkbox: true,
      loading: null,
      fullscreenLoading: false,
      userOrPhone:'username',
      formPhone:{
        VCode:'',
        Phone:''
      },
      btnName:'获取验证码',
      setintIndex:null,
      sendVCodeTime:59,
      userInfo:{
        UserId:'',
        UserCode:'',
        UserName:''
      },
      uuid:'',
      ClientId:'',
      QRCodeMsg:'',
      proxy:{},
      rememberFlag:false,
    }
  },
  methods: {
    changeType(type){
      this.userOrPhone = type;
    },
    getCode(){
      let self = this;
      if(!self.formPhone.Phone){
        self.$message.error('请输入手机号！');
        return
      }
      //如果存在定时器不再调用接口
      if(self.setintIndex){
        return
      }
      //TODO
      self.sendVerifyCodeForRegisterFun();
      //调用接口成功调用下面的方法

    },
    sendVerifyCodeForRegisterFun(){
      let self = this;
      self.$http.post(self.SendVerifyCodeForLogin, {
        Phone:self.formPhone.Phone
      }).then(result => {
        if (result.state == true) {
          self.$message.success('短信发送成功!');
          self.getReturnTime();
        } else {
          self.$message.error(result.message);
        }
      }, () => {
        // 请求失败
        self.$message.error('获取失败，请检查您的网络是否可用。');
      });
    },
    getReturnTime(){
      this.btnName = '倒计时:'+this.sendVCodeTime+'s';
      this.setintIndex = setInterval(()=>{
        --this.sendVCodeTime;
        this.btnName = '倒计时:'+this.sendVCodeTime+'s';
        if(this.sendVCodeTime == 0){
          clearInterval(this.setintIndex);
          this.btnName = '获取验证码';
          this.sendVCodeTime = 59;
        }
      },1000)
    },
    handleClick(){
      this.form.Username = '';
      this.form.Password = '';
      if(this.userOrPhone == 'username'){
        this.getCookie(0)
      }else{
        // this.getCookie(1)
      }
    },
    turnTo(url) {
      this.$router.push({
        path: url
      })
    },
    toRegesit() {
      this.$router.push({
        path: '/RegisterTH'
      })
    },
    toLogin() {
      var self = this;
      if(self.form.Username == ''){
        self.$message.error("请输入用户名");
        return
      }
      if(self.form.Password == ''){
        self.$message.error("请输入密码");
        return
      }
      if(self.form.Captcha == ''){
        self.$message.error("请输入验证码");
        return
      }
      self.fullscreenLoading = true;
      var rpassword = self.form.Password;//原密码
      self.$http.post(self.url.save, self.form)
        .then(result => {
          if (result.state == true) { // 注册成功
            // self.$message.success('登录成功!');
            self.$message({
              message: "登录成功!",
              type: "success",
              duration: 1000,
            });
            if(self.rememberFlag){
              self.setCookie(self.form.Username,rpassword,true,30,'username');
            }else{
              self.clearCookie('username')
            }
            localStorage.setItem('ms_isLogin', true);
            localStorage.setItem('ms_username', self.form.Username);
            localStorage.setItem('UserId',result.data.UserId);
            localStorage.setItem('UserCode',result.data.UserCode);
            let userCode = result.data.UserCode;
            let userId = result.data.UserId;
            EventBus.$emit('user-login', { userCode, userId });
            self.$router.push({
              path: '/My/UserInfo'
            });
          } else {
            self.$message.error(result.message);
            self.form.Password = '';
            self.refreshCaptcha()
          }
          self.fullscreenLoading = false;
        }, () => {
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
          self.fullscreenLoading = false;
        });
    },
    refreshCaptcha() {
      let self = this;
      self.captchaUrlTails = Math.random();
      self.form.Captcha = '';
    },
    refreshCaptchaP() {
      let self = this;
      self.captchaUrlTails = Math.random();
      self.formPhone.Captcha = '';
    },
    toLoginPhone(){
      var self = this;
      if(!self.formPhone.Phone){
        self.$message.error('请输入手机号！');
        return
      }
      if(!self.formPhone.VCode){
        self.$message.error('请输入短信验证码！');
        return
      }
      self.fullscreenLoading = true;
      self.$http.post(self.url.LoginForPhone, self.formPhone)
        .then(result => {
          if (result.state == true) {
            self.$message.success('登录成功!');
            localStorage.setItem('ms_isLogin', true);
            localStorage.setItem('ms_username', self.formPhone.Phone);

            self.$router.push({
              path: '/My/UserInfo'
            });
          } else {
            self.$message.error(result.message);
          }
          self.fullscreenLoading = false;
        }, () => {
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
          self.fullscreenLoading = false;
        });
    },
    setCookie (c_name, c_pwd, c_state, exdays,flag) {
      const exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); // 保存的天数
      if(flag=='username'){
        window.document.cookie = 'username' + '=' + c_name + ';path=/;expires=' + exdate.toGMTString();
        window.document.cookie = 'password' + '=' + c_pwd + ';path=/;expires=' + exdate.toGMTString();
        window.document.cookie = 'state' + '=' + c_state + ';path=/;expires=' + exdate.toGMTString();
      }else{
        window.document.cookie = 'username1' + '=' + c_name + ';path=/;expires=' + exdate.toGMTString();
        window.document.cookie = 'password1' + '=' + c_pwd + ';path=/;expires=' + exdate.toGMTString();
        window.document.cookie = 'state1' + '=' + c_state + ';path=/;expires=' + exdate.toGMTString();
      }

    },
    // 读取cookie
    getCookie (flag) {
      if (document.cookie.length > 0) {
        const arr = document.cookie.split('; ');
        // console.log(arr);
        for (let i = 0; i < arr.length; i++) {
          const arr2 = arr[i].split('=');
          if (arr2[0] === 'username' && flag == 0) {
            this.form.Username = arr2[1]
          } else if (arr2[0] === 'password' && flag == 0) {
            this.form.Password = arr2[1]
          } else if (arr2[0] === 'state' && flag == 0) {
            this.rememberFlag = Boolean(arr2[1])
          }else if (arr2[0] === 'state1' && flag == 1) {
            this.rememberFlag1 = Boolean(arr2[1])
          }else if (arr2[0] === 'username1' && flag == 1) {
            this.form.Username = arr2[1]
          }else if (arr2[0] === 'password1'  && flag == 1) {
            this.form.Password = arr2[1]
          }
        }
      }
    },
    // 清除cookie
    clearCookie(flag) {
      this.setCookie('', '', false, -1,flag)
    },
  },
  computed: {
    captchaFullUrl() {
      let self = this;
      return self.captchaUrl + "?tails=" + self.captchaUrlTails;
    }
  },
  created() {

  },
  mounted() {
    // this.refreshCaptcha();
    // this.getCookie(0);
  },
  watch: {}
}



// WEBPACK FOOTER //
// ./src/views/LoginTH/LoginTH.js